import MainRouter from './MainRouter';

const Router = () => {
  return <MainRouter />;
};

export default Router;
